export const SLUG_URL_MAP = {
  'home': '/',
  'about': '/about',
  'contact': '/contact',
  'specials': '/specials',
  'residential': '/services/residential',
  'commercial': '/services/commercial',
  'repair-maintenance': '/services/repair-maintenance',
  'renovations': '/services/renovations',
};

export const getPageUrl = (slug) => SLUG_URL_MAP[slug] || `/p/${slug}`;
